import React from 'react';
import { useSelector } from 'react-redux';
import { SwipeableList, Type as ListType } from 'react-swipeable-list';
import styled from 'styled-components';
import { AddInvoice, DenominationFooter } from 'components/pages/collection';
import { NoData } from 'components';
import { Box } from 'atoms';
import { InvoiceSwipeWrapper } from './InvoiceCardWrapper';

const Cards = styled(Box)`
	max-height: 75vh;
	padding-bottom: 2rem;
	overflow: auto;
`;

export default function MyCollectionsSwipe() {
	const { invoices = [], filteredInvoices = [] } = useSelector((state) => state.invoice);

	if (invoices?.length === 0) {
		return <NoData>Invoice Not Available</NoData>;
	}

	return (
		<Cards>
			{filteredInvoices?.length > 0 ? (
				<SwipeableList fullSwipe={false} threshold={0.25} type={ListType.IOS}>
					{filteredInvoices?.map((invoice) => (
						<InvoiceSwipeWrapper key={invoice?.id} invoice={invoice} />
					))}
					<AddInvoice />
				</SwipeableList>
			) : (
				<NoData>Invoice Not Found</NoData>
			)}
			<DenominationFooter />
		</Cards>
	);
}
